import ServiceBase from './serviceBase';
import {
  NotificationList,
  NotificationFilter,
  DeleteNotification,
  MarkNotificationAsRead,
  NotificationItem,
  UnreadNotifications,
  NotificationPopoverItem,
  NotificationItemsContainer,
} from './types/Notification';

class NotificationService extends ServiceBase {
  notifications = async (filter: NotificationFilter): Promise<NotificationList> => {
    const {
      pageNumber,
      // sortDescending, sortField
    } = filter;
    const queryParams = [
      `pageNumber=${pageNumber}`,
      `pageSize=10`,
      // `sortField=${sortField}`,
      // `sortDescending=${sortDescending}`
    ];
    return this.get<NotificationList>(`notifications?${queryParams.join('&')}`);
  };

  unreadNotifications = async (): Promise<UnreadNotifications> =>
    this.get<UnreadNotifications>('notifications/unread/count');

  popoverNotifications = async (): Promise<NotificationPopoverItem[]> =>
    this.get<NotificationPopoverItem[]>('notifications/unread?size=4');

  lastNotifications = async (): Promise<NotificationItemsContainer> =>
    this.get<NotificationItemsContainer>('notifications/summarized?size=4');

  markAsRead = async (payload: MarkNotificationAsRead): Promise<NotificationItem> =>
    this.put<NotificationItem>(`notifications/${payload.id}/read`);

  deleteNotification = async (payload: DeleteNotification): Promise<NotificationItem> =>
    this.delete<NotificationItem>(`notifications/${payload.id}`);

  deleteAll = async (): Promise<void> => this.delete<void>(`notifications/all`);

  markAllAsRead = async (): Promise<NotificationItem> =>
    this.put<NotificationItem>(`notifications/read/all`);
}

const notificationService = new NotificationService();

export default notificationService;
